import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SECURITY_DEPOSIT } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * A component that renders the security deposit fee as a line item.
 *
 * @component
 * @param {Object} props
 * @param {Array} props.lineItems - The line items to render
 * @param {Object} props.intl - The intl object
 * @returns {JSX.Element}
 */
const LineItemSecurityDepositMaybe = props => {
  const { lineItems, intl } = props;

  const securityDepositLineItem = lineItems.find(
    item => item.code === LINE_ITEM_SECURITY_DEPOSIT && !item.reversal
  );

  return securityDepositLineItem ? (
    <div className={css.securityDepositHoldRow}>
      <span className={css.securityDepositHoldLabel}>
        <FormattedMessage id="OrderBreakdown.refundableSecurityDepositHold" />
      </span>
      <span className={css.securityDepositHoldValue}>
        {formatMoney(intl, securityDepositLineItem.lineTotal)}
      </span>
    </div>
  ) : null;
};

export default LineItemSecurityDepositMaybe;
